import React, { useEffect, useState } from 'react'
import axios from "axios";

export function Enquire(props) {

    const [animateiom, setAnimateiom] = useState("");
    //const [animateiomremove, setAnimateiomremove] = useState(true);

    // Function to handle input change
    const handleChange = () => {  
        //setAnimateiomremove(false);
        document.querySelector("body").classList.remove("no-scroll");
        setAnimateiom(""); 
        setStatus("");
    };

    const [inputs, setInputs] = useState({ firstname: "", lastname: "", email: "", phone: "", subject: "", message: "" });
    const [status, setStatus] = useState(''); // To show success or error message
  
    const handleInput = (e) => {
      const name = e.target.name;
      const value = e.target.value;
  
      setInputs({
        ...inputs,
        [name]: value,
      });
    }
  
    // Validate the form inputs before sending the request
    const validateForm = () => {
      const { firstname, lastname, email, phone, subject, message } = inputs;
      if (!firstname || !lastname || !email || !phone || !subject || !message) {
        setStatus("All fields are required.");
        return false;
      }
  
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setStatus("Please enter a valid email address.");
        return false;
      }
  
      // // Phone validation (optional, simple check for 10 digits, adjust as needed)
      // const phoneRegex = /^[0-9]{7}$/;
      // if (!phoneRegex.test(phone)) {
      //   setStatus("Please enter a valid phone number (7 digits).");
      //   return false;
      // }
  
      return true;
    };
  
    const handleclickrequest = async (e) => {
      e.preventDefault();
  
      // Validate before submitting
      if (!validateForm()) return;
  
      const { firstname, lastname, email, phone, subject, message } = inputs;
  
      setStatus('Loading...'); // Display loading message while request is in progress
  
      try {
        const response = await axios.post(`http://cms.promovara.aamirsaeed.com/Umbraco/Api/Contact/ContactSendEmail`, null, {
          params: {
            firstname,
            lastname,
            email,
            phone,
            subject,
            message,
          },
        });
  
        if (response.status === 200) {
          setStatus('Your message has been sent successfully!');
          setInputs({ firstname: "", lastname: "", email: "", phone: "", subject: "", message: "" }); // Reset form fields
        } else {
          setStatus('There was an issue sending your message. Please try again later.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setStatus('There was an issue sending your message. Please try again later.');
      }
    };
  
    useEffect(() => {
        if (props.trigger) {
            setTimeout(function(){  
                //alert("1");
                document.querySelector("body").classList.add("no-scroll");
                setAnimateiom("eng-mo enq-bo enq-po");
                //$("body").addClass("ryi");
            }, 50);
        }
        // else {
        
        //     document.querySelector("body").classList.remove("no-scroll");
        //     setAnimateiom("");
        // }
        // if (!animateiomremove) {
        //     //setInputValue(true);
        //     //props.setTrigger(false)
        //     alert("1");
        //     setAnimateiom("eng-mo enq-bo");
        //     setTimeout(function(){  
        //         //alert("1");
        //         setAnimateiom("eng-mo");
        //         //$("body").addClass("ryi");
        //         alert("2");
        //     }, 300);
        //     setTimeout(function(){  
        //         //alert("1");
        //         setAnimateiom("");
        //         //$("body").addClass("ryi");
        //         //props.setTrigger(false);
        //         props.trigger(false);
        //         alert("3");
        //     }, 800);
        // }
    }, [props.trigger])

//console.log("Enquire Value", props.trigger);
  return (props.trigger) ? (
    <>
      <section className={`enquire-now ${props.trigger ? `${animateiom}` : ""}`}>
        <div className="bg"></div>     
        <article data-lenis-prevent>
            <div className="enq">
                <button className="close ir" onClick={() => props.setTrigger(handleChange)}>close</button> 
                <h2>Get in touch</h2>
                <p>Ready to get started? Fill out our form so we can better understand your needs and provide you with a customized solution.</p>
            </div>
            
            <form onSubmit={handleclickrequest}>
                <div className="form">
                    <div>
                        <label>First name*</label>
                        <input
                            type="text"
                            name="firstname"
                            required
                            value={inputs.firstname}
                            onChange={handleInput}
                            /> 
                    </div>
                    <div>
                        <label>Last name*</label>
                        <input
                            type="text"
                            name="lastname"
                            required
                            value={inputs.lastname}
                            onChange={handleInput} 
                            />
                    </div>
                    <div>
                        <label>Email*</label>
                        <input
                            type="email"
                            name="email"
                            required
                            value={inputs.email}
                            onChange={handleInput} 
                            />
                    </div>
                    <div>
                        <label>Phone number*</label>
                        <input
                            type="text"
                            name="phone"
                            required
                            value={inputs.phone}
                            onChange={handleInput} 
                            />
                    </div>
                    <div>
                        <label>Subject*</label>
                        <input
                            type="text"
                            name="subject"
                            required
                            value={inputs.subject}
                            onChange={handleInput} 
                            />
                    </div>
                    <div>
                        <label>Message*</label>
                        <textarea
              name="message"
              required
              value={inputs.message}
              onChange={handleInput} 
            ></textarea>
                    </div> 
                    <button type="submit" className="btn animate">Submit</button>
                </div>
            </form>
            
            <div className="enq">
                {/* Display status message */}
                {status && <p><br />{status}</p>}
            </div>
        </article>       
    </section>
    </>
  ) : "";
}
